// eslint-disable-next-line
import { BasicLayout, BlankLayout, PageView, RouteView } from '@/layouts'
import { dynamicList } from '@/api/userList'
// 前端路由表 (基于动态)
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView,
  403: () => import(/* webpackChunkName: "error" */ '@/views/exception/403'),
  404: () => import(/* webpackChunkName: "error" */ '@/views/exception/404'),
  500: () => import(/* webpackChunkName: "error" */ '@/views/exception/500'),

  // 你需要动态引入的页面组件
  // 首页
  smartTools: () => import('@/views/smartTools/SmartTools'),
  // 视频列表
  liveList: () => import('@/views/smartPlay/LiveList'),
  // 创建视频
  createLive: () => import('@/views/smartPlay/CreateLive'),
  // 批量创建视频
  createLiveBatch: () => import('@/views/smartPlay/createLiveBatch'),
  // 视频模板列表
  templateList: () => import('@/views/smartPlay/templateList'),
  // 创建视频模板
  createTemplate: () => import('@/views/smartPlay/CreateTemplate'),
  // 批量创建编辑单个视频l
  editGoodsVideo: () => import('@/views/smartPlay/EditGoodsVideo'),
  // 直播
  interactiveLiveList: () => import('@/views/interactiveLive/InteractiveLiveList'),
  // 直播模板
  liveTemplate: () => import('@/views/interactiveLive/LiveTemplate'),
  createInteractiveLive: () => import('@/views/interactiveLive/CreateInteractiveLive'),
  interactiveLiveDetail: () => import('@/views/interactiveLive/InteractiveLiveDetail'),
  barrageDetails: () => import('@/views/interactiveLive/BarrageDetails'),
  goodsList: () => import('@/views/goodsManage/GoodsList'),
  createGoods: () => import('@/views/goodsManage/CreateGoods'),
  goodsDetail: () => import('@/views/goodsManage/CreateGoods'),
  productEdit: () => import('@/views/goodsManage/CreateGoods'),
  picList: () => import('@/views/smartPic/PicList'),
  replaceCloth: () => import('@/views/smartPic/ReplaceCloth'),
  replaceBackdrop: () => import('@/views/smartPic/ReplaceBackdrop'),
  interactiveLibrary: () => import('@/views/interactiveLibrary/index'),
  messageCenter: () => import('@/views/messageCenter/index.vue'),
  personalCenter: () => import('@/views/personalCenter/index.vue'),
  //策略和知识库
  dataBoard: () => import('@/views/dataBoard/index.vue'),
  knowledgeList: () => import('@/views/knowledgeMange/KnowledgeList'),
  eBusinessModel: () => import('@/views/knowledgeMange/EBusinessModel'),
  createKnowledge: () => import('@/views/knowledgeMange/CreateKnowledge'),
  knowledgeDetail: () => import('@/views/knowledgeMange/KnowledgeDetail'),
  cloudLive: () => import('@/views/interactiveLive/components/cloud.vue'),

  personalCenter: () => import('@/views/personalCenter/index.vue'),
  userList: () => import('@/views/userManage/UserList'),
  createUser: () => import('@/views/userManage/CreateUser'),
  userDetails: () => import('@/views/userManage/UserDetails'),
  digitalPersonList: () => import('@/views/digitalPersonList/index'),
  CreateBrand: () => import('@/views/createBrand/index.vue'),
  // exception
  Exception403: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403'),
  Exception404: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  Exception500: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500'),
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*',
  redirect: '/404',
  hidden: true,
}

// 根级菜单
const rootRouter = {
  key: '',
  path: '/',
  component: 'BasicLayout',
  redirect: '/smartTools',
  meta: {
    title: '首页',
  },
  children: [],
}

// export const generatorStaticRouter = () => {

// }

/**
 * 动态生成菜单
 * @param token
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = (token) => {
  return new Promise((resolve, reject) => {
    dynamicList().then((res) => {
      // console.log(res.data)
      const result = res.data
      const menuNav = []
      const childrenNav = []
      //后端数据, 根级树数组,  根级 PID
      listToTree(result, childrenNav, 0)
      rootRouter.children = childrenNav
      menuNav.push(rootRouter)
      const routers = generator(menuNav)
      routers.push(notFoundRouter)
      resolve(routers)
    }, 100)
  })
  // setTimeout(() => {
  //   const result=[
  //     {
  //       name: 'smartTools',//路由路径名称
  //       parentId: 0,//父路由id,最顶层为0
  //       id: 1,//id
  //       // redirect:'/smartTools/smartTools',//重定向
  //       meta: {
  //         title: 'AI智能工具',//显示的路由名称
  //         show: true,//是否显示
  //         icon: 'home',//icon
  //         // hideChildren:true,//是否显示子节点
  //         // hiddenHeaderContent:true,//隐藏内容
  //         // target:'_blank'//跳转方式
  //         // keepAlive:true,//是否缓存
  //       },
  //       component: 'smartTools'//父节点为RouteView,子节点为具体渲染的页面组件名称
  //     },
  //     {
  //       name: 'goodsManage',
  //       parentId: 0,
  //       id: 2,
  //       meta: {
  //         title: '商品库',
  //         icon: 'shop',
  //         show: true,
  //         keepAlive:true,
  //         // hiddenHeaderContent: true,
  //       },
  //       redirect:'/goodsManage/goodsList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'goodsList',
  //       parentId: 2,
  //       id: 21,
  //       meta: {
  //         title: '商品列表',
  //         show: true,
  //         keepAlive:true,
  //         // hiddenHeaderContent: true,
  //       },
  //       component: 'goodsList'
  //     },
  //     {
  //       name: 'createGoods',
  //       parentId: 2,
  //       id: 22,
  //       meta: {
  //         title: '商品配置',
  //         show: true,
  //         // keepAlive:true,
  //       },
  //       component: 'createGoods'
  //     },
  //     {
  //       name: 'goodsDetail',
  //       parentId: 2,
  //       id: 23,
  //       meta: {
  //         title: '商品详情',
  //         show: false,
  //         keepAlive:true,
  //       },
  //       component: 'goodsDetail'
  //     },
  //     {
  //       name: 'productEdit',
  //       parentId: 2,
  //       id: 24,
  //       meta: {
  //         title: '编辑商品',
  //         show: false,
  //         // keepAlive:true,
  //       },
  //       component: 'productEdit'
  //     },
  //     {
  //       name: 'branding',
  //       parentId: 0,
  //       id: 3,
  //       meta: {
  //         title: '品牌营销',
  //         show: true,
  //         icon: 'youtube',
  //       },
  //       redirect:'/branding/interactiveLive/interactiveLiveList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'interactiveLive',
  //       parentId: 3,
  //       id: 31,
  //       meta: {
  //         title: '电商直播',
  //         show: true,
  //       },
  //       redirect:'/branding/interactiveLive/interactiveLiveList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'interactiveLiveList',
  //       parentId: 31,
  //       id: 311,
  //       meta: {
  //         title: '直播列表',
  //         show: true,
  //         keepAlive:true,
  //       },
  //       component: 'interactiveLiveList'
  //     },
  //     {
  //       name: 'createInteractiveLive',
  //       parentId: 31,
  //       id: 312,
  //       meta: {
  //         title: '直播配置',
  //         show: true,
  //         // keepAlive:true,
  //       },
  //       component: 'createInteractiveLive'
  //     },
  //     {
  //       name: 'interactiveLiveDetail',
  //       parentId: 31,
  //       id: 313,
  //       meta: {
  //         title: '直播详情',
  //         show: false,
  //       },
  //       component: 'interactiveLiveDetail'
  //     },
  //     {
  //       name: 'barrageDetails',
  //       parentId: 31,
  //       id: 314,
  //       meta: {
  //         title: '弹幕统计',
  //         show: false,
  //       },
  //       component: 'barrageDetails'
  //     },
  //     {
  //       name: 'brandCreation',
  //       parentId: 0,
  //       id: 4,
  //       meta: {
  //         title: '品牌创作',
  //         show: true,
  //         icon: 'table'
  //       },
  //       redirect:'/brandCreation/smartPlay/liveList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'smartPlay',
  //       parentId: 4,
  //       id: 41,
  //       meta: {
  //         title: '视频创作',
  //         show: true,
  //       },
  //       redirect:'/brandCreation/smartPlay/liveList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'liveList',
  //       parentId: 41,
  //       id: 411,
  //       meta: {
  //         title: '视频列表',
  //         show: true,
  //         keepAlive:true,
  //       },
  //       component: 'liveList'
  //     },
  //     {
  //       name: 'createLive',
  //       parentId: 41,
  //       id: 412,
  //       meta: {
  //         title: '视频配置',
  //         show: true,
  //         // keepAlive:true,
  //       },
  //       component: 'createLive'
  //     },
  //     {
  //       name: 'brandEquity',
  //       parentId: 0,
  //       id: 5,
  //       meta: {
  //         title: '品牌资产',
  //         show: true,
  //         icon: 'skin',
  //       },
  //       redirect:'/brandEquity/smartPic/digitalPersonList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'smartPic',
  //       parentId: 5,
  //       id: 51,
  //       meta: {
  //         title: '数智人工具',
  //         show: true,
  //       },
  //       redirect:'/brandEquity/smartPic/digitalPersonList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'digitalPersonList',
  //       parentId: 51,
  //       id: 511,
  //       meta: {
  //         title: '数智人列表',
  //         show: true,
  //         keepAlive:true,
  //       },
  //       component: 'digitalPersonList'
  //     },
  //     {
  //       name: 'replaceCloth',
  //       parentId: 51,
  //       id: 512,
  //       meta: {
  //         title: 'AI模特',
  //         show: false,
  //         keepAlive:true,
  //       },
  //       component: 'replaceCloth'
  //     },
  //     {
  //       name: 'knowledgeMange',
  //       parentId: 0,
  //       id: 6,
  //       meta: {
  //         title: '品牌策略',
  //         show: true,
  //         icon: 'read'
  //       },
  //       redirect:'/knowledgeMange/knowledgeList',//重定向
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'knowledgeList',
  //       parentId: 6,
  //       id: 61,
  //       meta: {
  //         title: '品牌知识列表',
  //         show: true,
  //         keepAlive:true,
  //       },
  //       component: 'knowledgeList'
  //     },
  //     {
  //       name: 'eBusinessModel',
  //       parentId: 6,
  //       id: 62,
  //       meta: {
  //         title: '品牌大模型',
  //         show: true,
  //         keepAlive:true,
  //       },
  //       component: 'eBusinessModel'
  //     },
  //     {
  //       name: 'dataBoard',
  //       parentId: 6,
  //       id: 63,
  //       meta: {
  //         title: '数据看板',
  //         show: true,
  //         keepAlive:true,
  //       },
  //       component: 'dataBoard'
  //     },
  //     {
  //       name: 'userManage',
  //       parentId: 0,
  //       id: 7,
  //       redirect: '/userManage/userList',
  //       meta: {
  //         title: '用户管理',
  //         show: true,
  //         keepAlive:true,
  //         icon: 'usergroup-add',
  //         hideChildren:true
  //       },
  //       component: 'RouteView'
  //     },
  //     {
  //       name: 'userList',
  //       parentId: 7,
  //       id: 71,
  //       meta: {
  //         title: '用户列表',
  //         show: false,
  //         keepAlive:true,
  //       },
  //       component: 'userList'
  //     },
  //     {
  //       name: 'createUser',
  //       parentId: 7,
  //       id: 72,
  //       meta: {
  //         title: '用户配置',
  //         show: false,
  //         // keepAlive:true,
  //       },
  //       component: 'createUser'
  //     },
  //     {
  //       name: 'userDetails',
  //       parentId: 7,
  //       id: 73,
  //       meta: {
  //         title: '用户详情',
  //         show: false,
  //         keepAlive:true,
  //       },
  //       component: 'userDetails'
  //     },

  //   ]
  //   const menuNav = []
  //   const childrenNav = []
  //   //后端数据, 根级树数组,  根级 PID
  //   listToTree(result, childrenNav, 0)
  //   rootRouter.children = childrenNav
  //   menuNav.push(rootRouter)
  //   const routers = generator(menuNav)
  //   routers.push(notFoundRouter)
  //   resolve(routers)
  // }, 100);

  // })
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map((item) => {
    const { title, show, hideChildren, hiddenHeaderContent, target, icon, keepAlive } = item.meta || {}
    const currentRouter = {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: item.path || `${(parent && parent.path) || ''}/${item.key}`,
      // 路由名称，建议唯一
      name: item.name || item.key || '',
      // 该路由对应页面的 组件 :方案1
      // component: constantRouterComponents[item.component || item.key],
      // 该路由对应页面的 组件 :方案2 (动态加载)
      component: constantRouterComponents[item.component || item.key] || (() => import(`@/views/${item.component}`)),

      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: title,
        icon: icon || undefined,
        hiddenHeaderContent: hiddenHeaderContent,
        target: target,
        keepAlive: keepAlive || false,
        permission: item.name,
      },
    }
    // 是否设置了隐藏菜单
    if (show === false) {
      currentRouter.hidden = true
    }
    // 是否设置了隐藏子菜单
    if (hideChildren) {
      currentRouter.hideChildrenInMenu = true
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    if (!currentRouter.path.startsWith('http')) {
      currentRouter.path = currentRouter.path.replace('//', '/')
    }
    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}

/**
 * 数组转树形结构
 * @param list 源数组
 * @param tree 树
 * @param parentId 父ID
 */
const listToTree = (list = [], tree, parentId) => {
  list.forEach((item) => {
    // 判断是否为父级菜单
    if (item.parentId === parentId) {
      const child = {
        ...item,
        key: item.key || item.name,
        children: [],
      }
      // 迭代 list， 找到当前菜单相符合的所有子菜单
      listToTree(list, child.children, item.id)
      // 删掉不存在 children 值的属性
      if (child.children.length <= 0) {
        delete child.children
      }
      // 加入到树中
      tree.push(child)
    }
  })
}
